import { Certificate } from "pmt-types/src/models/Certificate.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationAddCertificate = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (certificate: Certificate) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/certificates`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
          body: JSON.stringify(certificate),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to upsert certificate");
      }

      return (await response.json()) as Certificate;
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert certificate", error, data);
      },
    },
  );
};
